import { Pipe } from '@angular/core';
import { SpanInfoEnhanced } from '@benefitsui/app/api/benefits-clients';
import { DateTimeUtilities } from '@benefitsui/app/shared/utilities/dateTimeUtilities';

@Pipe({
  name: 'spanInfoEnhancedToString'
})
export class SpanInfoEnhancedToStringPipe {
  transform(spanInfoEnhanced: SpanInfoEnhanced | undefined): string {
    const spanInfoString = DateTimeUtilities.spanInfoEnhancedToString(spanInfoEnhanced);
    return spanInfoString;
  }
}
